export var tableSelectCellTheme = {
  baseStyle: {
    leftIcon: {
      display: 'inline-flex',
      marginRight: 'xs',
      flexShrink: 0
    },
    rightIcon: {
      display: 'inline-flex',
      marginLeft: 'auto',
      paddingLeft: 'm',
      flexShrink: 0
    },
    warningIcon: {
      display: 'inline-flex',
      marginLeft: 'xxs',
      flexShrink: 0
    }
  }
};
//# sourceMappingURL=_TableSelectCell.theme.js.map